// * Bootstrap libraries
import "./_bootstrap";
import "./overrides/validate";

// (() => {
// 	// * Tooltip initialization, remove it if not necessary
// 	for (const tooltipElement of document.querySelectorAll(
// 		'[data-toggle="tooltip"]',
// 	)) {
// 		new Tooltip(tooltipElement);
// 	}

// 	// * Toast initialization, remove it if not necessary
// 	for (const toastElement of document.querySelectorAll(".toast")) {
// 		new Toast(toastElement);
// 	}
// })();

(function ($, Drupal) {
  let navSpyEscapeListenerAdded = false;
  // Drupal.behaviors.burgerMenu = {
  //   attach: function (context, settings) {
  //     $(once('burgerMenu', '.burger', context)).on('click', function () {
  //       $('.block--fintepla-main-menu', context).slideDown();
  //     });

  //     $(once('closeMenu', '.mob-nav-close', context)).on('click', function (e) {
  //       e.preventDefault();
  //       $('.block--fintepla-main-menu', context).slideUp();
  //     });
  //   }
  // };

  // Drupal.behaviors.equalHeaderHeight = {
  //   attach: function (context, settings) {
  //     function updateMargin() {
  //       var headerHeight = $('.page__header', context).outerHeight();
  //       $('.page-content', context).css('margin-top', headerHeight + 'px');
  //     }

  //     $(document).ready(function () {
  //       updateMargin();
  //     });

  //     $(window).on('resize', function () {
  //       updateMargin();
  //     });
  //   }
  // };

  // Drupal.behaviors.referencesToggle = {
  //   attach: function (context, settings) {
  //     $(once('referencesToggle', '.references-title', context)).each(function () {
  //       $(this).on("click", function () {
  //         $(this).closest('.references').toggleClass('open');
  //       });
  //     });
  //   }
  // };

  Drupal.behaviors.videoPopupTrigger = {
    attach: function (context, settings) {
      $(once('videoPopupTrigger', '.js-play-video .video-play-btn', context)).each(function () {
        $(this).on('click', function (e) {
          e.preventDefault();
          $(this).parents('.js-play-video').find('.video-embed-field-launch-modal').trigger('click');
        })
      });
    }
  };

  Drupal.behaviors.videoPopupImageTrigger = {
    attach: function (context, settings) {
      $(once('videoPopupTrigger', '.js-play-video .image-wrapper', context)).each(function () {
        $(this).on('click', function (e) {
          e.preventDefault();
          $(this).parents('.js-play-video').find('.video-embed-field-launch-modal').trigger('click');
        })
      });
    }
  };


  Drupal.behaviors.videoAnchorPopupTrigger = {
    attach: function attach(context, settings) {
      var hash = window.location.hash.split('?')[0];

      if (hash) {
        var $target = $(hash);
        if ($target.length && $target.parents('.js-play-video').length && Drupal.behaviors.videoPopupImageTrigger) {
          setTimeout(() => {
            $target.parents('.js-play-video').find('.video-embed-field-launch-modal')[0].click();
          }, 100);
        }
      }
    }
  };

  Drupal.behaviors.closeModalDialog = {
    attach: function (context, settings) {
      $(once('modalDialogClose', '.modal-close', context)).each(function () {
        $(this).on('click', function (e) {
          e.preventDefault();
          $('.ui-dialog-titlebar-close').trigger('click');
        })
      });
    }
  };

  Drupal.behaviors.customTabs = {
    attach: function (context, settings) {
      $(once('customTabs', '.tabs-nav', context)).each(function () {
        if (!$('.tabs-nav .tab-link.active', context).length) {
          $('.tabs-nav .tab-link:first', context).addClass('active');
        }

        var activeTabTarget = $('.tabs-nav .tab-link.active', context).data('target');
        if (activeTabTarget) {
          $(activeTabTarget, context).addClass('active');
        }

        $('.tabs-nav .tab-link', context).on('click', function (e) {
          e.preventDefault();
          var target = $(this).data('target');

          $('.tabs-nav .tab-link', context).removeClass('active');
          $('.tab-content', context).removeClass('active');

          $(this).addClass('active');
          $(target, context).addClass('active');
        });
      });
    }
  };

  Drupal.behaviors.vimeoPlayer = {
    attach: function (context, settings) {
      once('vimeo-player', '.block-inline-blockla-hero .video-block', context)
        .forEach(function (element) {
          const iframe = element.querySelector('.video-embed-field-provider-vimeo iframe');
          if (iframe) {

            // Play button
            const playButton = element.querySelector('.video-control.play');

            function waitForVariable(varName) {
              return new Promise((resolve) => {
                let i = 1;
                const checkVar = setInterval(() => {
                  // Check if the variable is defined in the global scope (window object)
                  if (window[varName] !== undefined) {
                    clearInterval(checkVar); // Stop checking once it's defined
                    resolve(window[varName]); // Resolve the promise with the variable value
                  }

                  // Max 20 times.
                  if  (i > 20) {
                    clearInterval(checkVar);
                    resolve(null);
                  }
                  i++;
                }, 100); // Check every 100ms
              });
            }

            function isIframeLoaded(iframe) {
              try {
                iframe.contentWindow.location.href;
              } catch (error) {
                return true;
              }

              return false;
            }

            function waitForIframeLoad(iframe) {
              return new Promise((resolve) => {
                if (isIframeLoaded(iframe)) {
                  resolve();
                  return;
                }

                const checkReady = setInterval(() => {
                  if (isIframeLoaded(iframe)) {
                    clearInterval(checkReady);
                    resolve();
                  }
                }, 100);

                iframe.addEventListener('load', () => {
                  clearInterval(checkReady);
                  resolve();
                }, { once: true });
              });
            }

            Promise.all([
              waitForVariable('Vimeo'),
              waitForIframeLoad(iframe),
            ]).then(([VimeoApi]) => {
              if (!VimeoApi || !playButton) {
                return;
              }

              // Initialize the Vimeo Player.
              const player = new VimeoApi.Player(iframe);
              player.on('ended', () => {
                playButton.classList.add('active');
                playButton.setAttribute('aria-label', 'Play video');
              });

              playButton.addEventListener('click', async () => {
                try {
                  const isPaused = await player.getPaused();
                  if (isPaused) {
                    player.play();
                    playButton.classList.remove('active');
                    playButton.setAttribute('aria-label', 'Pause video');
                  } else {
                    player.pause();
                    playButton.classList.add('active');
                    playButton.setAttribute('aria-label', 'Play video');
                  }
                } catch (error) {
                }
              });

              const muteButton = element.querySelector('.video-control.mute');
              if (!muteButton) {
                return;
              }

              muteButton.addEventListener('click', () => {
                try {
                  player.getMuted().then(isMuted => {
                    if (isMuted) {
                      player.setMuted(false);
                      muteButton.classList.add('active');
                      muteButton.setAttribute('aria-label', 'Mute audio');
                    } else {
                      player.setMuted(true);
                      muteButton.classList.remove('active');
                      muteButton.setAttribute('aria-label', 'Unmute audio');
                    }
                  });
                } catch (error) {}
              });
            });
          }
        });
    }
  };

  //Sticky Spy Navigation
  Drupal.behaviors.navSpy = {
    attach: function (context) {
      if (!navSpyEscapeListenerAdded) {
        navSpyEscapeListenerAdded = true;
        document.addEventListener('keydown', function (e) {
          if (e.key !== 'Escape') {
            return;
          }
          document.querySelectorAll('.js-nav-spy__wrapper.is-nav-spy-open').forEach(function (el) {
            el.classList.remove('is-nav-spy-open');
            const t = el.querySelector('.js-nav-spy__toggle');
            if (t) {
              t.setAttribute('aria-expanded', 'false');
            }
          });
        });
      }

      once('nav-spy', '.js-nav-spy__container', context).forEach(function (container) {

        const $container = $(container);
        const $wrapper = $container.find('.js-nav-spy__wrapper');
        const mqMobileNavSpy = window.matchMedia('(max-width: 1023.98px)');

        // Mobile: "Jump to section" toggle + collapsible list (desktop markup unchanged)
        const $existingToggle = $wrapper.find('.js-nav-spy__toggle');
        if (!$existingToggle.length) {
          const $track = $wrapper.children().not('.js-nav-spy__toggle').first();
          if ($track.length) {
            const panelId = 'js-nav-spy-panel-' + Math.random().toString(36).slice(2, 11);
            const jumpLabel = (typeof Drupal !== 'undefined' && Drupal.t)
              ? Drupal.t('Jump to section')
              : 'Jump to section';
            $track.wrap(`<div class="js-nav-spy__mobile-panel" id="${panelId}"></div>`);
            const $toggle = $('<button type="button"></button>')
              .addClass('js-nav-spy__toggle theme-nav-spy__mobile-toggle')
              .attr('aria-expanded', 'false')
              .attr('aria-controls', panelId)
              .append(
                $('<span class="theme-nav-spy__mobile-toggle-label"></span>').text(jumpLabel),
                $('<svg class="theme-nav-spy__mobile-toggle-chevron" width="16" height="16" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>')
              );
            $wrapper.prepend($toggle);

            const closeMobilePanel = () => {
              $wrapper.removeClass('is-nav-spy-open');
              $toggle.attr('aria-expanded', 'false');
            };

            $toggle.on('click.navSpyToggle', function () {
              if (!mqMobileNavSpy.matches) {
                return;
              }
              const open = !$wrapper.hasClass('is-nav-spy-open');
              $wrapper.toggleClass('is-nav-spy-open', open);
              $toggle.attr('aria-expanded', open);
            });

            $(window).on('resize.navSpyMobilePanel', function () {
              if (!mqMobileNavSpy.matches) {
                closeMobilePanel();
              }
            });
          }
        }

        const $links = $container.find('.js-nav-spy__link');
        const $items = $container.find('.js-nav-spy__item');
        const sections = $links.map(function () {
          const id = $(this).attr('href');
          return $(id).length ? $(id) : null;
        });
        const activeClass = 'theme-nav-spy__item--active';

        const getItemBySectionId = (sectionId) => {
          if (!sectionId) {
            return $();
          }

          return $items.filter(function () {
            const href = $(this).find('.js-nav-spy__link').attr('href') || '';
            return href.substring(1) === sectionId;
          }).first();
        };

        const setActiveItem = ($item) => {
          const $activeItem = $item && $item.length ? $item.first() : $();

          $items.removeClass(activeClass);
          $links.removeAttr('aria-current');

          if ($activeItem.length) {
            $activeItem.addClass(activeClass);
            $activeItem.find('.js-nav-spy__link').first().attr('aria-current', 'true');
          }

          return $activeItem;
        };

        const scrollActiveItemIntoView = ($active) => {
          try {
            const $scrollParent = $container.find('.tw-overflow-x-auto').first();
            if ($scrollParent.length && $scrollParent.hasClass('tw-scroll-none')) {
              const sp = $scrollParent[0];
              if (sp.scrollWidth > sp.clientWidth) {
                const linkEl = $active.find('.js-nav-spy__link')[0];
                if (linkEl && typeof linkEl.scrollIntoView === 'function') {
                  // Use inline:'center' so the active item centers in the visible area
                  linkEl.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
                }
              }
            }
          }
          catch (e) {
            // ignore any errors from scrolling
          }
        };

        const marginSpace = 40;

        // read a CSS variable --spy-wrapper-offset (can be set on :root or wrapper) to fine-tune calculations
        const readSpyWrapperOffset = ($el) => {
          // try wrapper first, then root
          try {
            const style = window.getComputedStyle($el && $el.length ? $el[0] : document.documentElement);
            const raw = style.getPropertyValue('--spy-wrapper-offset') || style.getPropertyValue('--spy-wrapper-offset'.trim());
            if (raw) {
              const parsed = parseFloat(raw);
              if (!Number.isNaN(parsed)) {
                return parsed;
              }
            }
          }
          catch (e) {
            // ignore
          }
          return 50; // fallback
        };

        const getAnchorOffset = () => {
          const isSticky = $wrapper.is('.is-sticky');
          const isMobile = mqMobileNavSpy.matches;
          const h = isSticky && isMobile ? null : $wrapper.outerHeight();
          const fallback = readSpyWrapperOffset($wrapper);
          return (h && h > 0 ? h : fallback) + (!isSticky && isMobile ? 20 : marginSpace + 10);
        };

        // --- STICKY DETECTION (jump bar only; main header is not sticky) ---
        let stickyTop = $container.offset().top;

        $(window).on('resize.navSpy orientationchange.navSpy', function () {
          stickyTop = $container.offset().top;
        });

        const updateNavSpy = () => {
          const scrollTop = $(window).scrollTop();

          // Pin jump bar to viewport top once its natural position scrolls past
          if (scrollTop > stickyTop - 1) {
            $wrapper.addClass('is-sticky');
          } else {
            $wrapper.removeClass('is-sticky');
          }

          const anchorOffset = getAnchorOffset();
          const jitter = 4; // px threshold to account for minor scroll position fluctuations

          // Scrollspy activation
          let currentId = '';
          sections.each(function () {
            const sectionTop = $(this).offset().top - anchorOffset;
            if (Math.abs(scrollTop - sectionTop) < jitter || scrollTop >= sectionTop) {
              currentId = $(this).attr('id');
            }
          });

          if (currentId) {
            const $active = setActiveItem(getItemBySectionId(currentId));
            if ($active.length) {
              // Keep the active element visible when the desktop nav overflows.
              scrollActiveItemIntoView($active);
            }
          }
        };

        $(window).on('scroll.navSpy', updateNavSpy);
        updateNavSpy();

        // --- SMOOTH SCROLL ---
        $links.on('click', function (e) {
          e.preventDefault();
          setActiveItem($(this).closest('.js-nav-spy__item'));

          if (mqMobileNavSpy.matches) {
            $wrapper.removeClass('is-nav-spy-open');
            $wrapper.find('.js-nav-spy__toggle').attr('aria-expanded', 'false');
          }
          const target = $(this).attr('href');
          const $target = $(target);
          const anchorOffset = getAnchorOffset();

          if ($target.length) {
            $('html, body').animate({
              scrollTop: $target.offset().top - anchorOffset
            }, 400);
          }
        });

      });
    }
  };
  // Tabs with ribbon indicator
  Drupal.behaviors.themeTabsRibbon = {
    attach: function (context, settings) {
      $(once('customTabs', '.js-tab-ribbon', context)).each(function () {
        const $root = $(this);
        const $tabTriggersContainer = $root.find('.theme-tabs-ribbon__triggers');
        const $triggers = $tabTriggersContainer.find('[role="tab"]');
        const $panels = $root.find('.theme-tabs-ribbon__panel');
        const $indicator = $root.find('.theme-tabs-ribbon__indicator');
        const $sectionBg = $root.closest('.js-tabs-ribbon-bg');
        function getTriggerValue($t) {
          // prefer data-value, fallback to id suffix (tab-xxx)
          const v = $t.data('value');
          if (v !== undefined) return v;
          const id = $t.attr('id') || '';
          return id.replace(/^tab-/, '') || null;
        }

        function updateIndicator($btn) {
          // Button rect
          const rect = $btn[0].getBoundingClientRect();

          // Determine the correct container that holds all triggers. Prefer the
          // shared triggers parent (i.e. $triggers.parent()) because the
          // button's immediate parent is often an <li> and not the scrollable
          // viewport for the tabs.
          const containerEl = ($triggers && $triggers.length) ? $triggers.parent()[0] : $btn.parent()[0];
          const parentRect = containerEl ? containerEl.getBoundingClientRect() : $btn.parent()[0].getBoundingClientRect();

          // Compute left relative to the container content area and account for
          // the container's horizontal scroll position.
          const left = rect.left - parentRect.left + 4;
          const color = $btn.data('color') || 'purple';

          const colors = {
            'ds-purple': '#873D89',
            'ds-teal': '#009CA6'
          };

          const backgrounds = {
            'ds-purple': 'tw-bg-safety-bg-section-ds-purple',
            'ds-teal': 'tw-bg-safety-bg-section-ds-teal',
          }

          $root.css({
            '--tabs-active-left': `${left}px`,
            '--tabs-active-width': `${rect.width}px`,
            '--tabs-active-color': colors[color] || color,
          });
          $sectionBg.removeClass(Object.values(backgrounds).join(' '));
          if (backgrounds[color]) {
            $sectionBg.addClass(backgrounds[color]);
          }
          // Force a synchronous reflow so the CSS vars are applied and the
          // indicator updates immediately. This prevents a perceived delay
          // when the visual indicator depends on CSS custom properties.
          try {
            if ($root && $root[0]) void $root[0].offsetWidth;
          } catch (e) {
            // ignore
          }

          // if the triggers container scrolls (mobile), ensure the active
          // trigger is visible. Use an immediate scroll so the centering
          // happens without waiting for a smooth animation which can make
          // the indicator appear delayed. If you still want smooth
          // animation, change behavior to 'smooth'.
          try {
            const triggersContainer = containerEl;
            if (triggersContainer && triggersContainer.scrollWidth > triggersContainer.clientWidth) {
              if (typeof $btn[0].scrollIntoView === 'function') {
                $btn[0].scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'center' });
              } else {
                // fallback: center the button in the visible area immediately
                const desiredScroll = left - Math.round((triggersContainer.clientWidth - rect.width) / 2);
                triggersContainer.scrollLeft = desiredScroll;
              }
            }
          }
          catch (e) {
            // ignore any errors from scrolling
          }
        }

        function setActive(value, focus = true) {
          $triggers.each(function () {
            const $t = $(this);
            const isActive = (getTriggerValue($t) === value);

            $t.attr({
              'aria-selected': isActive,
            }).data('state', isActive ? 'active' : 'inactive');

            if (isActive && focus) $t.trigger('focus');
          });

          $panels.each(function () {
            const $p = $(this);
            const isActive = $p.attr('aria-labelledby') === `tab-${value}`;
            $p.attr('data-state', isActive ? 'active' : 'inactive');
            $p.prop('hidden', !isActive);
          });

          // try to find trigger by data-value first, then fallback by id-derived value
          let $activeTrigger = $triggers.filter(`[data-value="${value}"]`);
          if (!$activeTrigger.length) {
            $activeTrigger = $triggers.filter(function () { return getTriggerValue($(this)) === value; });
          }
          if ($activeTrigger.length) updateIndicator($activeTrigger);
        }

        // Inicializar
        const initial =
          $triggers.filter('[aria-selected="true"]').data('value') ||
          $triggers.first().data('value');
        setActive(initial, false);

        // Click
        $triggers.on('click', function () {
          const $btn = $(this);
          setActive($btn.data('value'));
        });

        // Resize
        $(window).on('resize.themeTabsRibbon', function () {
          const $active = $triggers.filter('[aria-selected="true"]');
          if ($active.length) updateIndicator($active);
        });
      });
    },
  };
  // Tabs for table safety page
  Drupal.behaviors.tableTabs = {
    attach: function (context, settings) {
      $(once('tableTabs', '.table-tabs, .table-tabs-alt', context)).each(function () {
        const $root = $(this);
        const $triggersContainer = $root.find('.table-tabs__triggers');
        const $triggers = $triggersContainer.find('[role="tab"], .tab');
        const $panels = $root.find('.table-tabs__panel');

        function setActive(index) {
          $triggers.each(function (i) {
            const $t = $(this);
            const active = i === index;
            $t.attr('aria-selected', active ? 'true' : 'false');
            $t.attr('tabindex', active ? '0' : '-1');
            $t.data('state', active ? 'active' : 'inactive');
          });

          $panels.each(function (i) {
            const $p = $(this);
            const active = i === index;
            $p.attr('data-state', active ? 'active' : 'inactive');
            if (active) {
              $p.prop('hidden', false);
            } else {
              $p.prop('hidden', true);
            }
          });
        }

        // determine initial active by aria-selected or fallback to first
        let initialIndex = 0;
        $triggers.each(function (i) {
          if ($(this).attr('aria-selected') === 'true') {
            initialIndex = i;
          }
        });

        // initialize state
        setActive(initialIndex);

        // clicks
        $triggers.on('click', function (e) {
          e.preventDefault();
          const idx = $triggers.index(this);
          if (idx >= 0) setActive(idx);
        });
      });
    }
  };

  /**
   * Accessible standalone accordions
   * - Adds ARIA attributes programmatically
   * - Animates collapse/expand by setting --panel-h on the .theme-accordion
   * - Uses ResizeObserver where available to keep heights in sync
   */
  Drupal.behaviors.themeAccordion = {
    attach: function (context, settings) {
      $(once('themeAccordion', '.theme-accordion', context)).each(function () {
        const $root = $(this);
        const $action = $root.find('.theme-accordion__action').first();
        const $button = $action.find('button').first();
        const $panel = $root.find('.theme-accordion__panel').first();
        const $panelContent = $panel.find('.theme-accordion__panel-content').first();

        if (!$button.length || !$panel.length || !$panelContent.length) return;

        // Utilities to generate unique IDs if missing
        function ensureId($el, prefix) {
          if (!$el.attr('id')) {
            const id = prefix + Math.random().toString(36).slice(2, 9);
            $el.attr('id', id);
          }
          return $el.attr('id');
        }

        const btnId = ensureId($button, 'acc-btn-');
        const panelId = ensureId($panel, 'acc-panel-');

        // Initialize ARIA and collapsed state
        $button.attr({
          'aria-expanded': 'false',
          'aria-controls': panelId,
          'id': btnId,
          'type': 'button'
        });

        $panel.attr({
          'id': panelId,
          'role': 'region',
          'aria-labelledby': btnId,
        });

        // Set initial collapsed state
        $panel.prop('hidden', true);
        $root.removeClass('is-open');

        // Measure and set CSS var --panel-h on the root
        function updatePanelHeight() {
          try {
            const contentEl = $panelContent[0];
            // get full height including margins
            const rect = contentEl.getBoundingClientRect();
            const style = window.getComputedStyle(contentEl);
            const marginTop = parseFloat(style.marginTop || 0);
            const marginBottom = parseFloat(style.marginBottom || 0);
            const total = Math.ceil(rect.height + marginTop + marginBottom);
            $root[0].style.setProperty('--panel-h', total + 'px');
          } catch (e) {
            // ignore
          }
        }

        // Toggle function
        function toggle(open) {
          const willOpen = (typeof open === 'boolean') ? open : ($button.attr('aria-expanded') !== 'true');
          if (willOpen) {
            updatePanelHeight();
            $panel.prop('hidden', false);
            // Allow the browser to read --panel-h before transitioning
            requestAnimationFrame(() => {
              $root.addClass('is-open');
              $button.attr('aria-expanded', 'true');
            });
          } else {
            $root.removeClass('is-open');
            $button.attr('aria-expanded', 'false');
            // Wait for transition to end before hiding (match CSS transition-duration)
            const onTransitionEnd = function (e) {
              if (e.target === $panel[0]) {
                $panel.prop('hidden', true);
                $panel.off('transitionend', onTransitionEnd);
              }
            };
            $panel.on('transitionend', onTransitionEnd);
          }
        }

        // Click handler
        $button.on('click', function (e) {
          e.preventDefault();
          toggle();
        });

        // Keyboard support (Space + Enter)
        $button.on('keydown', function (e) {
          if (e.key === ' ' || e.key === 'Spacebar' || e.key === 'Enter') {
            e.preventDefault();
            toggle();
          }
        });

        // Observe content size changes
        if (window.ResizeObserver) {
          const ro = new ResizeObserver(() => {
            // update the variable so expanded panels animate correctly
            updatePanelHeight();
          });
          ro.observe($panelContent[0]);
        } else {
          // Fallback: update on window resize
          $(window).on('resize.themeAccordion', function () {
            updatePanelHeight();
          });
        }

        // Ensure initial measurement (in case panels start open in markup later)
        updatePanelHeight();
      });
    }
  };

  /**
   * Expand / Collapse all accordions within a shared parent container.
   * Markup: place a `.theme-accordion__expand-all` element as a sibling (or
   * inside the same wrapper) of the `.theme-accordion` items it should control.
   * - Adds class `expanded` on the trigger when every accordion is open.
   * - Removes class `expanded` when at least one accordion is closed.
   */
  Drupal.behaviors.themeAccordionExpandAll = {
    attach: function (context) {
      $(once('themeAccordionExpandAll', '.theme-accordion__expand-all', context)).each(function () {
        const $trigger = $(this);
        const $parent = $trigger.closest('.js-theme-accordions');

        function getAccordions() {
          return $parent.find('.theme-accordion');
        }

        function allExpanded() {
          const $accordions = getAccordions();
          if (!$accordions.length) return false;
          return $accordions.filter('.is-open').length === $accordions.length;
        }

        function syncTriggerState() {
          const isAllOpen = allExpanded();
          $trigger.toggleClass('expanded', isAllOpen);
          $trigger.attr('aria-label', isAllOpen ? 'Collapse All' : 'Expand All');
        }

        $trigger.on('click', function (e) {
          e.preventDefault();
          const shouldOpen = !allExpanded();
          const $accordions = getAccordions();

          $accordions.each(function () {
            const $accordion = $(this);
            const isOpen = $accordion.hasClass('is-open');

            if (shouldOpen && !isOpen) {
              $accordion.find('.theme-accordion__action button').first().trigger('click');
            } else if (!shouldOpen && isOpen) {
              $accordion.find('.theme-accordion__action button').first().trigger('click');
            }
          });

          // Update trigger state after the rAF in toggle() fires
          requestAnimationFrame(() => {
            syncTriggerState();
          });
        });

        // Keep the trigger state in sync when individual accordions are toggled
        const observer = new MutationObserver(() => {
          syncTriggerState();
        });

        getAccordions().each(function () {
          observer.observe(this, { attributes: true, attributeFilter: ['class'] });
        });

        // Set initial state
        syncTriggerState();
      });
    }
  };

  Drupal.behaviors.blurValidation = {
    attach: function (context) {
      const formSelector = 'form.webform-submission-echo-locator-manage-listing-form, form.webform-submission-subscribe-v2-form';
      once('blurValidation', formSelector, context).forEach(function (form) {
        const $form = $(form);

        $form.on('blur', 'input[required], input[pattern], textarea[required], textarea[pattern]', function () {
          validateOnBlur(this);
        });

        $form.on('blur', 'select[required], select[aria-required="true"]', function () {
          validateOnBlur(this);
        });

        $form.on('change', 'select[required], select[aria-required="true"]', function () {
          validateOnBlur(this);
        });

        function selectNeedsBlurValidation(select) {
          if (select.required || select.getAttribute('aria-required') === 'true') {
            return true;
          }
          const name = select.name || '';
          return name.indexOf('type_of_facility') !== -1;
        }

        function bindSelect2BlurValidation() {
          $form.find('select.js-webform-select2').each(function () {
            const select = this;
            if (!selectNeedsBlurValidation(select)) {
              return;
            }
            const $select = $(select);
            if ($select.data('blurValidationSelect2')) {
              return;
            }
            $select.data('blurValidationSelect2', true);
            $select.on('select2:close.blurValidation', function () {
              setTimeout(function () {
                validateOnBlur(select);
              }, 150);
            });
            $select.on('select2:select.blurValidation select2:clear.blurValidation select2:unselect.blurValidation', function () {
              validateOnBlur(select);
            });
          });
        }

        bindSelect2BlurValidation();
        if (typeof requestAnimationFrame !== 'undefined') {
          requestAnimationFrame(bindSelect2BlurValidation);
        }
        setTimeout(bindSelect2BlurValidation, 0);
        setTimeout(bindSelect2BlurValidation, 300);

        function isConstraintInvalid(el) {
          if (!el.checkValidity()) {
            return true;
          }
          if (el.nodeName !== 'SELECT') {
            return false;
          }
          if (!selectNeedsBlurValidation(el)) {
            return false;
          }
          const value = el.value;
          return value === '' || value == null;
        }

        function validationMessageFor(el) {
          if (el.nodeName === 'SELECT' && (el.value === '' || el.value == null) && selectNeedsBlurValidation(el)) {
            const fromData =
              el.dataset.webformRequiredError ||
              el.getAttribute('data-webform-required-error');
            if (fromData) {
              return fromData;
            }
            if (el.name && el.name.indexOf('type_of_facility') !== -1) {
              return 'Please enter a valid type of facility.';
            }
          }
          return (
            el.dataset.msg ||
            el.validationMessage ||
            el.dataset.webformRequiredError ||
            el.getAttribute('data-webform-required-error') ||
            'This field is required.'
          );
        }

        function validateOnBlur(el) {
          const $el = $(el);
          const $wrapper = $el.closest('.form-group, .js-form-item, .form-item');
          const errorId = 'blur-error-' + (el.name || '').replace(/[^a-z0-9]/gi, '-');

          $wrapper.find('.blur-error-msg').remove();

          if (isConstraintInvalid(el)) {
            el.setAttribute('aria-invalid', 'true');
            $el.addClass('is-invalid').removeClass('is-valid');
            $wrapper.addClass('has-error');

            const msg = validationMessageFor(el);
            const $error = $('<div role="alert"></div>')
              .addClass('invalid-feedback blur-error-msg')
              .attr('id', errorId)
              .text(msg)
              .css('display', 'block');
            $el.attr('aria-describedby', errorId);
            var $select2 = $el.siblings('.select2-container');
            if ($select2.length) {
              $select2.after($error);
            } else {
              $el.after($error);
            }
          } else {
            el.setAttribute('aria-invalid', 'false');
            $el.removeClass('is-invalid').addClass('is-valid');
            $wrapper.removeClass('has-error');
            $el.removeAttr('aria-describedby');
          }
        }

        $form.on('submit', function () {
          $form
            .find(
              'input[required], input[pattern], select[required], select[aria-required="true"], textarea[required], textarea[pattern]',
            )
            .each(function () {
              validateOnBlur(this);
            });
          $form.find('select.js-webform-select2').each(function () {
            if (selectNeedsBlurValidation(this)) {
              validateOnBlur(this);
            }
          });
        });
      });
    }
  };

  /**
   * Keep SEND REQUEST disabled until all HTML5 constraints pass (required + patterns).
   */
  Drupal.behaviors.manageEchoLocatorSubmitGate = {
    attach: function (context) {
      once('manageEchoLocatorSubmitGate', 'form.webform-submission-echo-locator-manage-listing-form', context).forEach(function (form) {
        const $form = $(form);
        const $submit = $form.find('.manage-listing-actions input[type="submit"], .manage-listing-actions button[type="submit"]');
        if (!$submit.length) {
          return;
        }

        function getGatedFields() {
          return $form.find(
            'input[required], input[pattern], select[required], select[aria-required="true"], textarea[required], textarea[pattern]',
          );
        }

        function gatedFieldsAreValid() {
          return getGatedFields().toArray().every(function (field) {
            return field.checkValidity();
          });
        }

        function syncSubmitState() {
          $submit.prop('disabled', !gatedFieldsAreValid());
        }

        syncSubmitState();

        $form.on('input.manageEchoLocatorGate change.manageEchoLocatorGate', 'input, select, textarea', syncSubmitState);

        $form.find('select.js-webform-select2').each(function () {
          $(this).on('select2:select.manageEchoLocatorGate select2:clear.manageEchoLocatorGate select2:unselect.manageEchoLocatorGate', syncSubmitState);
        });
      });
    }
  };

  // Disable clear button in Select2 dropdown.
  Drupal.behaviors.disableSelect2ClearButton = {
    attach: function (context) {
      once('disableSelect2ClearButton', 'select.js-webform-select2', context).forEach(function (select) {
        const $select = $(select);

        // coudldn't reinitialize select2 with allowClear: false because it causes other issues, so just remove the clear button after selection
        $select.on('select2:select', function (e) {
          $select.siblings('.select2-container').find('.select2-selection__clear').remove();

          // change selected text color
          $select.siblings('.select2-container').addClass('has-value');
        });
      });
    }
  };

  Drupal.behaviors.backToTop = {
    attach: function (context, settings) {
      $(once('backToTop', '#back-to-top', context)).each(function () {
        var $btn = $(this);

        $(window).on('scroll', function () {
          if ($(window).scrollTop() > 100) {
            $btn.addClass('is-visible');
          } else {
            $btn.removeClass('is-visible');
          }
        });

        $btn.on('click', function (e) {
          e.preventDefault();
          $('html, body').animate({ scrollTop: 0 }, 400);
        });
      });
    }
  };

})(jQuery, Drupal);
